import React from "react";
import { cn } from "@/lib/utils";

export const GlassCard = React.forwardRef(
    ({ children, className = "", hover = false, padding = "p-6", testId, ...rest }, ref) => (
        <div
            ref={ref}
            data-testid={testId}
            className={cn("glass-card", hover && "glass-card-hover", padding, className)}
            {...rest}
        >
            <div className="relative z-10">{children}</div>
        </div>
    ),
);

GlassCard.displayName = "GlassCard";
